import _extends from '@babel/runtime/helpers/extends';
import 'react';
import { jsx } from '@emotion/react';

function SvgFormulaChangeGlyph(props) {
  return jsx("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.07 9c2.41 0 4.37 1.96 4.37 4.37h4.49V39.21H8V13.37h2.99c0-2.41 1.97-4.37 4.38-4.37s4.37 1.96 4.37 4.37h6.96c0-2.41 1.96-4.37 4.37-4.37Zm0 1.25c-1.72 0-3.12 1.4-3.12 3.12h6.24c0-1.72-1.4-3.12-3.12-3.12Zm-15.71 0c-1.72 0-3.12 1.4-3.12 3.12h6.24c0-1.72-1.4-3.12-3.12-3.12ZM9.25 37.97h29.43V20.41H9.25v17.56Zm0-18.84h29.41v-4.5h-3.43a4.332 4.332 0 0 1-2.84 2.91l-.38-1.19c.88-.28 1.55-.92 1.9-1.72H19.54a4.332 4.332 0 0 1-2.84 2.91l-.38-1.19c.88-.28 1.55-.92 1.9-1.72H9.25v4.5Zm8.3 13.54h-1.24v-5.65h-1.63v-1.04c1.16 0 1.74-.22 1.94-1.01h.93v7.7Zm5.18-6.69c.66 0 .99.4.99 1.08 0 .65-.25 1.08-.79 1.73l-2.42 2.98v.9h4.53v-1.16h-2.83l1.8-2.27c.54-.67.95-1.33.95-2.24 0-1.31-.76-2.18-2.21-2.18-1.41 0-2.31.94-2.3 2.42h1.23c-.01-.88.43-1.26 1.05-1.26Zm6 4.41c.01.9.56 1.27 1.3 1.27.72 0 1.19-.46 1.19-1.18 0-.83-.58-1.25-1.58-1.25h-.34v-1.08h.32c.92 0 1.34-.33 1.34-1.08 0-.66-.36-1.09-1.01-1.09-.59 0-1.07.37-1.07 1.22h-1.23c0-1.48.9-2.38 2.29-2.38 1.46 0 2.27.97 2.27 2.2 0 .95-.54 1.46-1.02 1.64.64.19 1.29.77 1.29 1.86 0 1.39-.99 2.29-2.48 2.29-1.53 0-2.5-.88-2.5-2.42h1.23Z",
    fill: "currentColor"
  }));
}

export { SvgFormulaChangeGlyph as default };
